<template>
  <svg
    v-if="gSiteName === 'xoilaczxc'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15_4677)">
      <path
        d="M11.0766 6.05496C10.6854 6.05496 10.3672 6.37324 10.3672 6.76445V8.59961C10.3672 8.99082 10.6854 9.30906 11.0766 9.30906C11.4679 9.30906 11.7861 8.99082 11.7861 8.59961V6.76445C11.7861 6.37324 11.4679 6.05496 11.0766 6.05496Z"
        fill="white"
      />
      <path
        d="M19.824 6.51342L16.445 3.20518C15.6583 2.43479 14.6185 2.01053 13.5173 2.01053H13.228C13.1978 1.98577 13.1647 1.96366 13.1288 1.94475L12.244 1.47901C11.9576 1.32819 11.6034 1.43823 11.4526 1.72456C11.4045 1.81592 11.3832 1.91417 11.3854 2.01057H8.61454C8.61677 1.9142 8.59548 1.81592 8.54739 1.72456C8.39665 1.43819 8.04224 1.32823 7.75595 1.47901L6.87122 1.94475C6.83532 1.96366 6.8022 1.98577 6.772 2.01053H6.48267C5.38149 2.01053 4.34169 2.43479 3.55493 3.20518L0.176026 6.51342C-0.0493645 6.73409 -0.0595989 7.09354 0.152784 7.32667L2.3622 9.7521C2.56782 9.97784 2.91232 10.0078 3.15388 9.821L4.52567 8.75991L4.6647 18.0115C4.6695 18.3316 4.9304 18.5886 5.25056 18.5886H14.7495C15.0697 18.5886 15.3306 18.3316 15.3354 18.0115L15.4744 8.75991L16.8462 9.821C17.0877 10.0078 17.4322 9.97788 17.6379 9.7521L19.8473 7.32667C20.0596 7.09354 20.0493 6.73409 19.824 6.51342ZM8.21384 9.89499C8.21384 10.2186 7.9515 10.4809 7.6279 10.4809C7.30431 10.4809 7.04196 10.2186 7.04196 9.89499V5.46901C7.04196 5.14542 7.30431 4.88307 7.6279 4.88307C7.9515 4.88307 8.21384 5.14542 8.21384 5.46901V9.89499ZM12.958 8.59959C12.958 9.63698 12.1141 10.4809 11.0767 10.4809C10.0393 10.4809 9.19532 9.63698 9.19532 8.59959V6.76444C9.19532 5.72706 10.0393 4.88307 11.0767 4.88307C12.1141 4.88307 12.958 5.72702 12.958 6.76444V8.59959Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_4677">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else-if="gSiteName === 'xoilactivi'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="as-not-change-color"
  >
    <g clip-path="url(#clip0_491_587)">
      <path
        d="M10.0861 2.36433C11.0438 2.36433 11.8271 1.58529 11.8323 0.627686H8.33545C8.3385 0.648148 8.34061 0.668922 8.34147 0.69005C8.38017 1.62887 9.14649 2.36433 10.0861 2.36433Z"
        fill="#B4BEC1"
      />
      <path
        d="M17.471 1.72134L16.5385 1.37939L4.29834 17.3793C4.29834 17.3793 4.2994 19.0847 4.2994 19.2342L17.6813 1.85577C17.6222 1.79669 17.5507 1.75053 17.471 1.72134Z"
        fill="#B4BEC1"
      />
      <path
        d="M19.9254 5.80604L18.3142 2.93823L5.68311 19.3721H15.1209C15.4416 19.3721 15.7017 19.112 15.7017 18.7912V8.23487L16.2199 8.81641C16.4295 9.05163 16.7883 9.07683 17.0287 8.87346L19.7941 6.53391C20.0067 6.35409 20.0618 6.04877 19.9254 5.80604Z"
        fill="#B4BEC1"
      />
      <path
        d="M4.29819 15.4675L15.3961 0.960638L14.5852 0.663293C14.5212 0.639819 14.4535 0.627808 14.3852 0.627808H14.211H12.9936C12.9936 0.629842 12.9939 0.631798 12.9939 0.633833C12.9854 2.22865 11.681 3.52617 10.0861 3.52617C8.52134 3.52617 7.24519 2.30146 7.18079 0.737981C7.17926 0.700422 7.18161 0.663685 7.18697 0.627847H5.78898H5.61472C5.54649 0.627847 5.47881 0.639858 5.41476 0.663332L2.52911 1.72145C2.39918 1.7691 2.29049 1.86159 2.22269 1.98229L0.074458 5.80606C-0.06189 6.04878 -0.00684222 6.35415 0.20572 6.53396L2.97114 8.87352C3.21164 9.07684 3.57037 9.05161 3.77991 8.81647L4.29815 8.23493L4.29819 15.4675Z"
        fill="#B4BEC1"
      />
    </g>
    <defs>
      <clipPath id="clip0_491_587">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-else
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_406_2658)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.824 6.51412L16.445 3.20588C15.6583 2.43549 14.6185 2.01123 13.5173 2.01123H13.228C13.1978 1.98647 13.1647 1.96436 13.1288 1.94545L12.244 1.47971C11.9576 1.32889 11.6034 1.43893 11.4526 1.72526C11.4045 1.81662 11.3832 1.91487 11.3854 2.01127H8.61454C8.61677 1.91491 8.59548 1.81662 8.54739 1.72526C8.39665 1.43889 8.04224 1.32893 7.75595 1.47971L6.87122 1.94545C6.83532 1.96436 6.8022 1.98647 6.772 2.01123H6.48267C5.38149 2.01123 4.34169 2.43549 3.55493 3.20588L0.176026 6.51412C-0.0493646 6.73479 -0.0595989 7.09424 0.152784 7.32737L2.3622 9.7528C2.56782 9.97854 2.91232 10.0085 3.15388 9.8217L4.52567 8.76061L4.6647 18.0122C4.6695 18.3323 4.9304 18.5893 5.25056 18.5893H14.7495C15.0697 18.5893 15.3306 18.3323 15.3354 18.0122L15.4744 8.76061L16.8462 9.8217C17.0877 10.0085 17.4322 9.97858 17.6379 9.7528L19.8473 7.32737C20.0596 7.09424 20.0493 6.73479 19.824 6.51412ZM17.1355 8.56401L15.2646 7.11686C15.089 6.981 14.8518 6.95612 14.6519 7.05241C14.4519 7.14866 14.3235 7.34963 14.3202 7.57155L14.1723 17.4174H5.82771L5.67978 7.57155C5.67646 7.34963 5.54806 7.14866 5.3481 7.05241C5.14821 6.95612 4.91099 6.98108 4.7354 7.11686L2.86442 8.56405L1.3997 6.95608L4.37474 4.04323C4.94122 3.48858 5.68982 3.18311 6.48263 3.18311H13.5173C14.3101 3.18311 15.0587 3.48858 15.6252 4.04323L18.6002 6.95604L17.1355 8.56401ZM7.6279 4.88379C7.30431 4.88379 7.04196 5.14613 7.04196 5.46973V9.8957C7.04196 10.2193 7.30431 10.4816 7.6279 10.4816C7.95149 10.4816 8.21384 10.2193 8.21384 9.8957V5.46973C8.21384 5.14613 7.95149 4.88379 7.6279 4.88379ZM9.19533 6.76516C9.19533 5.72773 10.0393 4.88379 11.0767 4.88379C12.114 4.88379 12.958 5.72773 12.958 6.76516V8.60031C12.958 9.6377 12.1141 10.4816 11.0767 10.4816C10.0393 10.4816 9.19533 9.6377 9.19533 8.60031V6.76516ZM11.0767 9.30977C11.4679 9.30977 11.7861 8.99152 11.7861 8.60031V6.76516C11.7861 6.37395 11.4679 6.05566 11.0767 6.05566C10.6854 6.05566 10.3672 6.37395 10.3672 6.76516V8.60031C10.3672 8.99152 10.6854 9.30977 11.0767 9.30977Z"
        fill="#9C9C9C"
      />
    </g>
    <defs>
      <clipPath id="clip0_406_2658">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
